
import t from "../../../../service/translate.service";
import { Modal } from "antd";

const AlreadyBookedModal = (props) => {

  return (
    <Modal
      open={true}
      onCancel={() => props.setShowAlreadyBookedModal(false)}
      footer={[
        <button
          className="button primary small"
          key="back"
          onClick={() => props.setShowAlreadyBookedModal(false)}
          aria-label={t.GOBACK}
        >
          {t.CONSULTATIONS_BACK}
        </button>
      ]}
      aria-labelledby="alreadyBookedModalTitle"
      role="dialog"
      aria-live="assertive"
    >
      <div className="modal-body-wrapper">
        <p className="modal-p" id="alreadyBookedModalTitle" aria-live="assertive" role='alert'>
          {t.CONSULTATIONS_ALREADY_BOOKED_DATE}
        </p>
      </div>
    </Modal>
  );
};

export default AlreadyBookedModal;
